import { render } from "./Error404.vue?vue&type=template&id=789069fb&scoped=true&ts=true"
import script from "./Error404.vue?vue&type=script&lang=ts"
export * from "./Error404.vue?vue&type=script&lang=ts"

import "./Error404.vue?vue&type=style&index=0&id=789069fb&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-789069fb"]])

export default __exports__